import { cloneDeep } from '_utils';
import BannerService from '_services/rest/modules/banner';
import { MODEL } from './components/BannerModel';

export default {
  state: {
    bannerList: null,
    bannerEdit: null,
  },

  mutations: {
    setBannerList(state, response) {
      state.bannerList = response;
    },
    setBanner(state, response) {
      state.bannerEdit = Object.assign(cloneDeep(MODEL), response);
    },
  },

  actions: {
    saveBanner({ commit }, user) {
      return BannerService.save(user).then(response => {
        commit('setBanner', user);
        return response;
      });
    },
    getBanner({ commit }, id) {
      return BannerService.getBanner(id)
        .then(response => {
          commit('setBanner', response);
          return response;
        });
    },
    getBannerList({ commit }, params) {
      return BannerService.getList(params)
        .then(response => {
          commit('setBannerList', response);
        });
    },
  },
};
